module.exports = __webpack_public_path__ + "static/media/eye.073db132.svg";